export enum BannerEndpointsEnum {
  ROTATING_BANNER = "/homepageBanner",
}
